module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#speaker",
      toString: function () {
        return this.url;
      }
    }